import { defineComponent as _defineComponent } from 'vue'
import type { NewContentCollection } from '@ilteducation/content-collections-types';
import { useRoute } from 'vue-router/composables';
import { computed, onBeforeMount, ref } from 'vue';
import { getOne } from '@/data-provider/contentCollections';
import eventBus from '@/foundations/services/eventBus';

type Props = {
  title: string;
  realm?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    title: null,
    realm: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  realm?: string;
}



const route = useRoute();

const Collection: NewContentCollection = {
  name: undefined,
  realm: undefined,
  contents: {
    type: 'ContentsByReferences',
    references: [],
  },
};

const item = ref<NewContentCollection>(Collection);

const isClone = computed(() => !!route.query.source);

onBeforeMount(async () => {
  const { source, realm } = route.query;
  try {
    if (!source) {
      return;
    }
    const collection = await getOne(props.realm ?? realm, source);
    console.debug('Cloning collection:', collection);
    if (collection) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { id, createdAt, lastUpdatedAt, ...rest } = collection;
      item.value = { ...rest, name: `${rest.name} (Clone)` };
    }
  } catch (e) {
    console.error(e);
    eventBus.$emit('snackbarV2.open', { text: e, color: 'error' });
  }
});

return { __sfc: true,props, route, Collection, item, isClone }
}

})